// TODO(sap-sync-flag): delete this tab when the SAP sync feature flag is removed
import { isSapInvoiceSyncEnabledForDoc, isSapProfileSyncEnabledForDoc, } from "../../feature_flag.generated";
export const SAP_SYNC_LEVEL_LABELS = {
    off: "Off",
    profile: "Profile only",
    invoices: "Profile & invoices",
};
const isScope = (value) => typeof value === "boolean" || value === "true" || value === "false" || value === "profile" || value === "invoices";
/**
 * Whether the flag is a map this tab can extend. An older flag held an array of doc_ids instead - which
 * Firebase hands back as an array, or as `{"0": doc_id}` once it has gaps - and that reads as off for everyone
 * now, so it isn't a map to build on: its doc_ids would be spread over as if they were scopes.
 */
const isDocMap = (flag) => typeof flag === "object" && flag !== null && Object.values(flag).every(isScope);
export const getSapSyncLevel = (flag, doc_id) => isSapInvoiceSyncEnabledForDoc(flag, doc_id)
    ? "invoices"
    : isSapProfileSyncEnabledForDoc(flag, doc_id)
        ? "profile"
        : "off";
/** The level every doctor is on when the flag is a single scope rather than a map, otherwise null */
export const getLevelForAll = (flag) => {
    if (isDocMap(flag)) {
        return null;
    }
    const level = getSapSyncLevel(flag, "");
    return level === "off" ? null : level;
};
/**
 * The setFeatureFlag calls that move `doc_ids` to `level`, in order. A map is updated in place, leaving every other
 * doctor as they are. The endpoint won't set individual doctors while the flag covers everyone, so that flag is
 * turned off first and then spread over `all_doc_ids`, so the rest keep the level they had - which also means
 * doctors outside `all_doc_ids` (e.g. anyone who adds a profile later) are no longer covered.
 */
export const setSapSyncLevel = (flag, doc_ids, level, all_doc_ids) => {
    const scope = level === "off" ? false : level;
    const levelForAll = getLevelForAll(flag);
    if (!levelForAll) {
        return [{ doctors: Object.fromEntries(doc_ids.map(doc_id => [doc_id, scope])) }];
    }
    const doctors = Object.fromEntries(all_doc_ids.map(doc_id => [doc_id, levelForAll]));
    for (const doc_id of doc_ids) {
        if (scope) {
            doctors[doc_id] = scope;
        }
        else {
            delete doctors[doc_id];
        }
    }
    // The endpoint needs at least one doctor, and with nobody left turning it off is the whole change
    return Object.keys(doctors).length ? [{ all: false }, { doctors }] : [{ all: false }];
};
/** Whether applying `updates` stops the flag covering every doctor */
export const narrowsFromAll = (flag, updates) => !!getLevelForAll(flag) && updates.some(update => "doctors" in update);
